import ApiService from "@/common/services/http/api.service";

const DashboardService = {
  /**
   * Buscar Pendencias para gráfico
   * @param clienteID id do cliente
   * @param params filtros opcionais
   * @returns {*}
   */
  async getDashboardGetPendencias(clienteID, params = null) {
    const { data: result } = await ApiService.get(
      "/dashboard",
      `cliente/${clienteID}`,
      params
    );

    return result;
  },

  /**
   * Buscar ScoreCards
   * @param clienteID id do cliente
   * @param params filtros opcionais
   * @returns {*}
   */
  async getScoreCards(clienteID, params = null) {
    const { data: result } = await ApiService.get(
      "/dashboard/getScoreCards",
      `${clienteID}`,
      params
    );

    return result;
  },
};

export default DashboardService;
